import { useEffect, useMemo, useState } from 'react';

import { Box } from '@mui/material';

import SymbolsPreview from '@/components/SymbolsPreview';
import { getTimeSince } from '@/utils/getTimeSince';
import { parseSymbolKeys } from '@/utils/parseSymbolKeys';

import { FeedIcon } from './FeedIcon';
import { FeedLink } from './FeedLink';
import { FeedInfo } from '../types';

export const FeedRow = ({
  values: { Title, Content, CTAType, CTAValue, CTALabel },
  symbol,
  transactionTime
}: FeedInfo) => {
  const [time, setTime] = useState(getTimeSince(transactionTime));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeSince(transactionTime));
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [transactionTime]);

  const symbols = useMemo(() => {
    if (CTAType === 'Symbol') {
      return parseSymbolKeys(CTAValue);
    }
  }, [CTAType, CTAValue]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'row', gap: '8px' }}>
        <FeedIcon Type={symbol.Type} />
        <Box sx={{ typography: 'p', display: 'inline', fontSize: '14px' }}>
          <Box sx={{ display: 'inline', fontWeight: 'bold' }}>{Title}</Box> |{' '}
          {Content.replaceAll(/(^")|("$)/g, '')}{' '}
          {CTAType && (
            <FeedLink
              CTALabel={CTALabel}
              CTAType={CTAType}
              CTAValue={CTAValue}
              open={open}
              setOpen={setOpen}
            />
          )}{' '}
          | {time}
        </Box>
      </Box>
      {open && symbols && (
        <SymbolsPreview items={symbols.map(symbol => ({ symbol, date: transactionTime }))} />
      )}
    </Box>
  );
};
